import { loanApplicationsApi } from 'app/services/api';

import { HTTP_RESPONSE_STATUS_CODES } from 'constants/http';
import { getDefaultErrorMessage } from 'utils/axios';

import { showErrorMessageAction } from 'store/global/actions/messages.actions';

export const AttestationRecordOutcome = {
  RECORDED: 'recorded',
  UNAVAILABLE: 'unavailable',
  ERROR: 'error',
};

export const recordDisclosureAttestationsAction = params => async dispatch => {
  try {
    const { data } = await loanApplicationsApi.recordDisclosureAttestations(params);

    return { outcome: AttestationRecordOutcome.RECORDED, entries: data?.entries ?? [] };
  } catch (error) {
    if (error?.response?.status === HTTP_RESPONSE_STATUS_CODES.NOT_FOUND) {
      return { outcome: AttestationRecordOutcome.UNAVAILABLE };
    }

    const message = getDefaultErrorMessage(error);

    dispatch(showErrorMessageAction({ message, err: error }));

    return { outcome: AttestationRecordOutcome.ERROR, message };
  }
};
